import UniversityProgramsDesk from "./Desk/UniversityProgramsDesk";
import UniversityProgramsMob from "./Mob/UniversityProgramsMob";

const UniversityPrograms = () => {
  return <>{window.innerWidth <= 768 ? <UniversityProgramsMob /> : <UniversityProgramsDesk />}</>;
};

export default UniversityPrograms;
